import React from 'react';
import { TeamTabContext } from './TeamTabContext';
import type { TeamTabContextValue } from './TeamTabContext';

interface TeamTabProps {
  value: TeamTabContextValue;
  children: React.ReactNode;
}

/**
 * Wrapper component that provides the TeamTabContext to all team sub-panels.
 * In M2 this wraps the existing inline JSX; M3-M7 progressively extract
 * panels into dedicated components inside team/panels/.
 */
export const TeamTab: React.FC<TeamTabProps> = ({ value, children }) => {
  return <TeamTabContext.Provider value={value}>{children}</TeamTabContext.Provider>;
};
